export function getSocialMetas({
  url,
  title = 'Restaurant V12',
  description = 'Kom lekker eten', // TODO add real fallback text
  image = '', // TODO add logo image as fallback
  keywords,
}: {
  image?: string
  url: string
  title?: string
  description?: string
  keywords?: string
}) {
  return [
    { title },
    { name: 'description', content: description },
    { name: keywords, content: keywords },
    { name: 'image', content: `${ENV.STRAPI_API_URL}${image}` },
    { name: 'og:url', content: url },
    { name: 'og:title', content: title },
    { name: 'og:description', content: description },
    { name: 'og:image', content: `${ENV.STRAPI_API_URL}${image}` },
  ]
}
